import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AccountFilters = ({ filters, onFilterChange, totalAccounts, filteredCount }) => {
  const handleSearchChange = (e) => {
    onFilterChange?.({ ...filters, searchTerm: e?.target?.value });
  };

  const handleFilterChange = (key, value) => {
    onFilterChange?.({ ...filters, [key]: value });
  };

  const clearFilters = () => {
    onFilterChange?.({
      status: 'all',
      complianceRange: 'all',
      billingStatus: 'all',
      tier: 'all',
      searchTerm: ''
    });
  };

  const hasActiveFilters = 
    filters?.status !== 'all' ||
    filters?.complianceRange !== 'all' ||
    filters?.billingStatus !== 'all' ||
    filters?.tier !== 'all' ||
    filters?.searchTerm !== '';

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-foreground">Filter Accounts</h3>
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={clearFilters}
          >
            <Icon name="X" size={14} className="mr-1" />
            Clear Filters
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Search */}
        <div className="lg:col-span-2">
          <label className="block text-sm font-medium text-foreground mb-2">Search</label>
          <div className="relative">
            <Icon name="Search" size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              placeholder="Company name, email..."
              value={filters?.searchTerm}
              onChange={handleSearchChange}
              className="w-full pl-10 pr-4 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
        </div>

        {/* Status */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Status</label>
          <select
            value={filters?.status}
            onChange={(e) => handleFilterChange('status', e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="suspended">Suspended</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        {/* Compliance Range */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Compliance</label>
          <select
            value={filters?.complianceRange}
            onChange={(e) => handleFilterChange('complianceRange', e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="all">All Scores</option>
            <option value="excellent">90-100% (Excellent)</option>
            <option value="good">70-89% (Good)</option>
            <option value="warning">50-69% (Warning)</option>
            <option value="critical">&lt;50% (Critical)</option>
          </select>
        </div>

        {/* Billing Status */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Billing</label>
          <select
            value={filters?.billingStatus}
            onChange={(e) => handleFilterChange('billingStatus', e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="all">All Billing</option>
            <option value="current">Current</option>
            <option value="due_soon">Due Soon (7 days)</option>
            <option value="overdue">Overdue</option>
          </select>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Showing <span className="font-medium text-foreground">{filteredCount}</span> of{' '}
          <span className="font-medium text-foreground">{totalAccounts}</span> accounts
        </p>
      </div>
    </div>
  );
};

export default AccountFilters;